export default {"src":"/_next/static/media/hunnysCollectionGif.f96278a1.gif","height":700,"width":700};